<template lang="html">
  <div class="cw-home">
    <cw-loader v-if="!authenticated && authenticating" />
    <cw-intro v-else-if="!authenticated" />
    <div v-else>
      <section class="section is-vertical-paddingless">
        <div class="has-text-centered">
          <div class="container">
            <img class="hero-logo" src="../assets/red-cw-logo.svg" />
            <!-- <p class="title is-5 has-text-weight-bold">5 Projects - 8 boxes</p>
            <p class="subtitle is-6">no pending orders</p> -->
          </div>
        </div>
      </section>
      <section class="featured-buttons">
        <div class="columns is-mobile is-multiline">
          <router-link to="/projects" class="column is-third">
            <div class="has-text-centered heading box is-floating">
              <icon name="projects" scale="3"></icon>
              <p>Projects</p>
            </div>
          </router-link>
          <router-link to="/orders" class="column is-half">
            <div class="has-text-centered heading box is-floating">
              <icon name="orders" scale="3" label="set"></icon>
              <p>Orders</p>
            </div>
          </router-link>
          <router-link
            v-if="canViewInvoices"
            to="/invoices"
            class="column is-half"
          >
            <div class="has-text-centered heading box is-floating">
              <icon name="invoices" scale="3"></icon>
              <p>Invoices</p>
            </div>
          </router-link>
          <router-link v-if="canViewUsers" to="/users" class="column is-half">
            <div class="has-text-centered heading box is-floating">
              <icon name="profile" scale="3"></icon>
              <p>Users</p>
            </div>
          </router-link>
          <!-- TODO add v-if="$cordova && $cordova.nfc" when actually deploying to hide scanning on devices that do not support it -->
          <a class="column is-half" @click="$modal.show('scan')">
            <div class="has-text-centered heading box is-floating">
              <icon
                name="scan"
                scale="3"
                label="set"
                class="has-text-primary"
              ></icon>
              <p>Scan</p>
            </div>
          </a>
          <a
            v-if="canCreateOrders"
            class="column is-half"
            @click="$modal.show('SetRequest')"
          >
            <div class="has-text-centered heading box is-floating">
              <icon name="set" scale="3" label="set"></icon>
              <p>Set</p>
            </div>
          </a>
        </div>
      </section>
    </div>
    <div class="is-growable is-padded-small centerit">
      <cw-app-version />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import permissionsRequired from '@/components/mixins/permissions-required';

import Intro from '@/components/Intro';

export default {
  name: 'cw-home',
  // share common functionality with component mixins
  mixins: [permissionsRequired],
  props: {},
  // variables
  data() {
    return {};
  },
  computed: {
    userInfo() {
      return (this.user && this.user.info) || null;
    },
    authenticated() {
      return (this.user && this.user.authenticated) || false;
    },
    ...mapState({
      user: state => state.user,
      authenticating: state => state.user.authenticating,
    }),
  },
  components: {
    [Intro.name]: Intro,
  },
  // methods
  watch: {},
  methods: {},
};
</script>

<style lang="stylus" scoped>
.hero-logo {
  margin: 1rem
  max-width: 400pt
  height: 70pt
}

.featured-buttons {
  max-width: 300pt
  margin: auto
}
</style>
